import { get } from './index';

export const getHotelsContracts = ({ hotelId }) => {
  return get(`hotels/${hotelId}/contractsAvailable`);
};
